import { Component } from "react";
import styles from "./product-list-item.module.less";
import UiBkgImage from "@rnb/ui-bkg-image";
import LinkWrapper from "components/block-elements/link-wrapper/link-wrapper";
import ProductPrice from "components/block-elements/product-price/product-price";
import SpeechBubbleProductListing from "components/block-elements/speech-bubble-product-listing/speech-bubble-product-listing";
import { extract, ECommerceHelper, JetshopHelper } from "@parksandresorts/core";
import SiteConfig from "components/stores/site-configuration-store";

const cssForGridType = {
  HALF: styles.half,
  THIRD: styles.third,
  CENTER: styles.center,
};

export default class ProductListItem extends Component {
  constructor(props) {
    super(props);
    this.imageUrl = extract(props, "productImage.file.url");
    this.name = extract(props, "productName");
    this.shortDescription = extract(props, "shortDescription");
    this.link = extract(props, "productPageLink.slug");
    this.label = extract(props, "label");
    this.labelComponentTheme = extract(props, "labelComponentTheme");
    this.disableLabel = extract(props, "disableLabel");
    this.componentTheme = extract(props, "componentTheme");
    this.jetshopConfig = ECommerceHelper.getJetshopConfig();
    this.currencyDisplayName = this.jetshopConfig.currencyDisplayName;
    this.gridType = extract(props, "gridType");
    this.gridTypeCss = this.gridType ? cssForGridType[this.gridType] : null;
    this.componentTheme = extract(props, "componentTheme");
    this.wrapperClassName = extract(props, "wrapperClassName");
    this.customPriceText = extract(props, "customPriceText");
    this.id = extract(props, "id");
    this.ignoreCustomPrice = extract(props, "ignoreCustomPrice");
    this.locationState = extract(props, "locationState");
    this.productType = extract(props, "productData.productType", "Standard");
    this.disableSoldOut = extract(props, "disableSoldOut", false);
    this.openInOverlay = extract(props, "openInOverlay", true);
    this.soldOut = this.isProductSoldOut();
    this.soldOutLabel = SiteConfig.getLabel("PRODUCT_SOLD_OUT", "Slutsålt");
  }

  isProductSoldOut() {
    if (JetshopHelper.isTimeSlotProduct(this.productType)) {
      const timeSlot = extract(this.props, "timeSlots[0]", null);
      if (timeSlot && timeSlot.quantity > 0) {
        return false;
      }
      return true;
    }

    return false;
  }

  renderSoldOut() {
    return (
      <div className={styles.soldOutWrapper}>
        <h2 className={styles.soldOutText}>{this.soldOutLabel}</h2>
      </div>
    );
  }

  render() {
    return (
      <div
        className={[
          styles.wrapper,
          this.wrapperClassName,
          this.gridTypeCss,
          this.componentTheme ? `component-theme-${this.componentTheme}` : "",
          this.props.forceMobile ? "" : styles.standard,
        ].join(" ")}
      >
        <LinkWrapper
          url={this.soldOut && !this.disableSoldOut ? null : this.link}
          toOverlay={this.openInOverlay}
          locationState={this.locationState ? this.locationState : undefined}
        >
          <div id={this.props.id ? this.props.id : null} className={styles.innerWrapper}>
            {this.soldOut && !this.disableSoldOut && this.renderSoldOut()}
            <div className={styles.imageWrapper}>
              <UiBkgImage
                className={styles.image}
                smallDeviceImageMaxWidth={600}
                largeDeviceImageMaxWidth={450}
                breakPointSmallDevice={9999}
                backgroundSizing="cover"
                imageUrlForSmallDevice={this.imageUrl}
                imageUrlForLargeDevice={this.imageUrl}
              />
            </div>
            <div className={styles.textWrapper}>
              <h3 className={styles.name}>{this.name}</h3>
              <p className={[styles.description, "p_small"].join(" ")}>{this.shortDescription}</p>
              <ProductPrice
                price={this.props.price ? this.props.price : undefined}
                previousPrice={this.props.previousPrice ? this.props.previousPrice : undefined}
                currencyDisplayName={this.currencyDisplayName}
                priceClassName="bold"
                customPriceText={this.ignoreCustomPrice ? undefined : this.customPriceText}
              />

              <span className={["icon-chevron-right", styles.linkIcon].join(" ")} />
            </div>
          </div>
          {this.label && !this.disableLabel && (
            <div className={styles.labelWrapper}>
              <SpeechBubbleProductListing
                speechBubbleInverseColors={true}
                componentTheme={this.labelComponentTheme ? this.labelComponentTheme : undefined}
                title={this.label}
                bubbleBelongsTo="2"
              />
            </div>
          )}
        </LinkWrapper>
      </div>
    );
  }
}
